<template lang="pug">
	.pronunciation-editor.flex-col.space-large
		.flex-row.space
			.flex-col.flex-2
				.font-small.upper.grey {{$tCaption('Text')}}
				.font-large {{text}}
			.flex-col.flex-1
				.font-small.upper.grey {{$tCaption('Alphabet')}}
				DxSelectBox(:value.sync="innerValue.alphabet", :data-source="alphabets", display-expr="name", value-expr="id", :dropDownOptions="{ width: '320px' }")
		.flex-col
			.font-small.upper.grey {{$tCaption('Phoneme')}}
			DxTextBox(:value.sync="innerValue.ph", :placeholder="$tCaption('Enter phoneme for selected text')")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import Loader from 'app-core/Loader.vue';
	import DxSelectBox from 'devextreme-vue/select-box';
	import { ALPHABETS } from 'app-core/constants';

	export default {
		translationCategory: 'insertion.SSMLPronunciationEditor',
		name: 'pronunciation-editor',
		components: {
			DxButton, DxTextBox, DxSelectBox,
			Loader
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: ['text', 'value'],
		data() {
			return {
				innerValue: _.merge({
					alphabet: 'sapi',
					ph: ''
				}, this.value),
				alphabets: ALPHABETS.toLocale('name', this)
			};
		},
		watch: {
			innerValue: {
				handler() {
					this.$emit('change', this.innerValue);
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.pronunciationEditor = this;
		},
		methods: {

		}
	};
</script>
<style lang='scss'>
	.pronunciation-editor {

	}
</style>
